import axios from 'axios';
// import printJS from 'print-js';
import printJS from 'print-js-updated';

import store from '@/store';
import auth from '@/extensions/restricted-area/store/api/auth';
import { compact } from '@/helpers';

const W2P_ENDPOINT = `${process.env.VUE_APP_W2P_HTTP}${process.env.VUE_APP_W2P_ENDPOINT}`;

export default {
    shoppingCart(action = 'preview') {
        // possible values are: review / print / download
        return new Promise((resolve, reject) => {
            const token = auth.getToken();
            if (token) {
                const config = {
                    headers: { Authorization: `Bearer ${token}` },
                    responseType: 'blob'
                };

                axios
                    .get(`${W2P_ENDPOINT}${process.env.VUE_APP_W2P_SHOPPING_CART_ROUTE}`, config)
                    .then(response => {
                        if (response.headers && response.headers.authorization) {
                            const jwt = response.headers.authorization.split('Bearer');
                            if (jwt.length) {
                                const token = compact(jwt)[0].trim();
                                store.commit('auth/addTokenToState', token);
                            }
                        }
                        if (response.error) reject(response.error);

                        const url = window.URL.createObjectURL(response.data);
                        // window.open(url, '__blank');

                        const link = document.createElement('a');
                        link.href = url;
                        switch (action) {
                            case 'preview':
                                link.setAttribute('target', '__blank');
                                document.body.appendChild(link);
                                link.click();
                                break;

                            case 'download':
                                link.setAttribute('target', '__self');
                                link.setAttribute('download', 'shopping-cart.pdf');
                                document.body.appendChild(link);
                                link.click();
                                break;

                            case 'print':
                                printJS(url);
                                break;
                        }

                        setTimeout(() => window.URL.revokeObjectURL(url), 300);

                        resolve(response);
                    })
                    .catch(err => reject(err));
            } else {
                reject();
            }
        });
    }
};
